<template>
  <b-form-group
    class="d-inline-block w-24 filters-width"
    :label="inputLabel"
    :label-for="inputId"
  >
    <b-form-input
      :id="inputId"
      :value="value"
      class="d-inline-block"
      :placeholder="inputPlaceholder"
      @input="$emit('input', $event)"
      @keydown.enter="emitEnterKeydown"
    />
  </b-form-group>
</template>

<script>
export default {
  emits: ["enter"],
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    inputId: {
      type: String,
      required: false,
      default: "searchCommand",
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    inputLabel: {
      type: [String, null],
      default: "جتسجو",
    },
    inputPlaceholder: {
      type: [String, null],
      default: "جستجو...",
    },
  },
  methods: {
    emitEnterKeydown() {
      this.$emit("enter");
    },
  },
  components: {
    BFormGroup,
    BFormInput,
  },
};
import { BFormGroup, BFormInput } from "bootstrap-vue";
</script>